import { queryOptions } from "@tanstack/react-query";

import { api } from "@platform/core/api";
import type { BillingCard, BillingCost, BillingCostSeries, BillingOverview } from "./billing.types";

export function billingQueryOptions() {
	return queryOptions({
		queryKey: ["billing", "status"],
		queryFn: () => api.get<BillingOverview>("/platform/billing/status"),
	});
}

export function billingCardQueryOptions() {
	return queryOptions({
		queryKey: ["billing", "card"],
		queryFn: () => api.get<BillingCard>("/platform/billing/card"),
	});
}

export function billingCostQueryOptions() {
	return queryOptions({
		queryKey: ["billing", "cost"],
		queryFn: () => api.get<BillingCost>("/platform/billing/cost"),
	});
}

export function billingCostSeriesQueryOptions() {
	return queryOptions({
		queryKey: ["billing", "cost-series"],
		queryFn: () => api.get<BillingCostSeries>("/platform/billing/cost-series"),
	});
}
